/** 传输协议 */
export enum TranProtocol {
  TCP = 'TCP',
  UDP = 'UDP',
}

/** 访问入口使用场景 */
export enum UsageScenario {
  HTTP = 'HTTP',
  HTTPS = 'HTTPS',
  OPENAI = 'OpenAI',
  ANTHROPIC = 'Anthropic',
  SSH = 'SSH',
  TCP = 'TCP',
  UDP = 'UDP',
}

/** 使用场景 -> 应用层协议 / 传输层协议 */
export interface UsageScenarioConfig {
  protocol: string;
  tranProtocol: TranProtocol;
}
